// Vista previa en pantalla de la etiqueta (imita backend/templates/etiqueta_apertura.html):
// rollo de 62 mm, 28 mm de alto la corta y 42 mm la completa. La banda de
// conservación se distingue sin color: congelado con fondo negro, refrigerado
// con marco grueso y seco sin marco (solo una raya debajo).
import React from 'react';
import { tamanoNombrePt } from '../../utils/etiquetas';

const PX_MM = 4.5;
const mm = (v) => `${(v * PX_MM).toFixed(1)}px`;
const pt = (v) => `${(v * 0.3528 * PX_MM).toFixed(1)}px`;

const FUENTE = '"Arial Narrow", "Roboto Condensed", "DejaVu Sans Condensed", Arial, sans-serif';
const MONO = '"DejaVu Sans Mono", "Roboto Mono", ui-monospace, monospace';

const estiloBanda = (conservacion, completa) => {
  const base = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: mm(completa ? 6.2 : 5.4),
    padding: `0 ${mm(1.4)}`,
    borderRadius: mm(1),
    flex: 'none',
  };
  if (conservacion === 'congelado') return { ...base, background: '#000', color: '#fff' };
  if (conservacion === 'seco') {
    return { ...base, borderBottom: `${mm(0.3)} solid #000`, borderRadius: 0, paddingLeft: 0, paddingRight: 0 };
  }
  return { ...base, border: `${mm(0.7)} solid #000` };
};

const VistaEtiqueta = ({ datos, titulo = 'Vista previa' }) => {
  if (!datos) return null;
  const completa = datos.formato === 'completa';
  const nombrePt = tamanoNombrePt(datos.nombre);
  const conservacionTexto = String(datos.conservacion || '').toUpperCase();

  return (
    <div data-testid="etiqueta-vista">
      {titulo && <p className="text-xs font-medium text-gray-500 mb-1.5">{titulo}</p>}
      <div className="bg-gray-100 rounded-lg p-3 overflow-x-auto">
        <div
          className="mx-auto bg-white shadow-sm ring-1 ring-gray-300"
          style={{
            width: mm(62),
            height: mm(completa ? 42 : 28),
            padding: `${mm(1.4)} ${mm(1.8)} ${mm(1.2)} ${mm(1.8)}`,
            display: 'flex',
            flexDirection: 'column',
            gap: mm(0.8),
            overflow: 'hidden',
            color: '#000',
            fontFamily: FUENTE,
            boxSizing: 'border-box',
          }}
          aria-label={`Etiqueta de ${datos.nombre || 'producto'}`}
        >
          <div style={estiloBanda(datos.conservacion, completa)}>
            <b style={{ fontSize: pt(completa ? 10.5 : 9.5), letterSpacing: '0.06em', fontWeight: 800 }}>{conservacionTexto}</b>
            <span style={{ fontSize: pt(7.5), fontWeight: 700 }}>{datos.rango}</span>
          </div>

          <div
            style={{
              fontWeight: 800,
              fontSize: pt(nombrePt),
              lineHeight: 1.08,
              maxHeight: mm(nombrePt * 2 * 1.08 * 0.3528 + 0.2),
              overflow: 'hidden',
              flex: 'none',
            }}
          >
            {datos.nombre}
          </div>

          <div style={{ display: 'flex', gap: mm(1.2), alignItems: 'stretch', flex: 'none' }}>
            <div style={{ flex: '1 1 0', display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: mm(0.4), minWidth: 0 }}>
              {(datos.datos_fecha || []).map((d) => (
                <div key={d.etiqueta} style={{ fontSize: pt(5.8), lineHeight: 1.05, whiteSpace: 'nowrap' }}>
                  {d.etiqueta}
                  <strong style={{ display: 'block', fontSize: pt(8), fontFamily: MONO, fontWeight: 700 }}>{d.valor}</strong>
                </div>
              ))}
            </div>
            <div
              style={{
                flex: 'none',
                width: mm(completa ? 29 : 28),
                border: `${mm(0.6)} solid #000`,
                borderRadius: mm(1),
                padding: `${mm(0.5)} ${mm(1)}`,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
              }}
            >
              <small style={{ fontSize: pt(6.2), fontWeight: 700, lineHeight: 1.1 }}>Consumir antes de</small>
              <strong style={{ fontFamily: MONO, fontWeight: 800, fontSize: pt(12.5), lineHeight: 1.05, whiteSpace: 'nowrap' }}>
                {datos.caduca_texto}
              </strong>
              {datos.caduca_hora && (
                <em style={{ fontStyle: 'normal', fontFamily: MONO, fontWeight: 800, fontSize: pt(9), lineHeight: 1.05 }}>
                  a las {datos.caduca_hora}
                </em>
              )}
            </div>
          </div>

          {datos.alergenos_texto && (
            <div style={{ fontSize: pt(6.4), lineHeight: 1.15, maxHeight: mm(7.8), overflow: 'hidden', flex: 'none' }}>
              {datos.alergenos_texto}
            </div>
          )}

          {(datos.avisos || []).map((a) => (
            <div key={a} style={{ fontSize: pt(6.6), fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.03em', flex: 'none' }}>
              {a}
            </div>
          ))}

          <div
            style={{
              marginTop: 'auto',
              borderTop: `${mm(0.3)} solid #000`,
              paddingTop: mm(0.5),
              display: 'flex',
              justifyContent: 'space-between',
              gap: mm(1),
              fontSize: pt(6),
              lineHeight: 1.1,
              flex: 'none',
            }}
          >
            <span>
              Lote <span style={{ fontWeight: 800, fontFamily: MONO }}>{datos.lote}</span>
              {datos.lote_fabricante ? ` · Fab. ${datos.lote_fabricante}` : ''}
            </span>
            <span style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>
              {datos.caducidad_envase_texto ? `Cad. envase ${datos.caducidad_envase_texto}` : 'Duetto Catering'}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VistaEtiqueta;
